<template lang="pug">
  
  v-btn(icon large text :disabled="!hasNotifications" @click="$emit('click')")
    v-badge(v-model="hasNotifications" overlap color="red")
      span(slot="badge") {{ total }}
      v-icon {{ hasNotifications ? 'mdi-bell' : 'mdi-bell-off' }}

</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {

  mounted() {
    this.registerServiceWorker()
  },

  computed: {
    hasNotifications() {
      return this.total > 0
    },
    total() {
      return this.$store.getters['entities/notifications/items'].length
    },
  },

  methods: {
    ...mapActions('webpush', [
      'registerServiceWorker',
      'unsubscribe',
    ]),
  }
}
</script>